import { AnyAction, Reducer } from 'redux';

export const STORE_DASHBOARD = 'dashboard/store';
export const STORE_DASHBOARD_LIVECOUNT = 'dashboard/store-liveorder';
export const STORE_DASHBOARD_COMPLETEDORDER = 'dashboard/store-completedorder';
export const STORE_DASHBOARD_ONHOLD = 'dashboard/store-onhold';
export const STORE_DASHBOARD_RETURNED = 'dashboard/store-returned';
export const STORE_DASHBOARD_DESIGNREADY = 'design-ready/store-design-ready-user';
export const STORE_CHART = 'dashboard/store-chart';
export const STORE_LARGEST_NUMBER = 'greatest/store-greatest';
export const STORE_DASHBOARD_COMPLETEDORDERCNT = 'dashboard/store-completedordercnt';

export interface DataItemInitial {
    rowno: string;
    odate: string;
    mno: string;
    completed: string;
    intat: string;
}

export interface DataItem {
    rowno: number;
    odate: string;
    mno: number;
    completed: number;
    intat: number;
}

export interface UserOrderData {
    rowno: string;
    total: string;
    completed: string;
    returned: string;
    onhold: string;
    designready: string;
    completedcnt: string;
}

export interface UserOrderState {
    userOrderdata: UserOrderData;
    items: DataItem[];
    rowno: string;
    total: string;
    completed: string;
    returned: string;
    designready: string;
    onhold: string;
    greatest: string;
    completedcnt: string;
}

const initialState: UserOrderState = {
    userOrderdata: {
        rowno: '',
        total: '',
        completed: '',
        returned: '',
        onhold: '',
        designready: '',
        completedcnt: ''
    },
    rowno: '',
    total: '',
    completed: '',
    returned: '',
    designready: '',
    onhold: '',
    items: [],
    greatest: 'intat',
    completedcnt: ''
};

const reducer: Reducer<UserOrderState> = (state: UserOrderState = initialState, action: AnyAction): UserOrderState => {
    switch (action.type) {
        case STORE_DASHBOARD:
            return {
                ...state,
                userOrderdata: action.userOrderdata
            };
        case STORE_DASHBOARD_LIVECOUNT:
            return {
                ...state,
                total: action.total
            };
        case STORE_DASHBOARD_COMPLETEDORDER:
            return {
                ...state,
                completed: action.completed
            };
        case STORE_DASHBOARD_ONHOLD:
            return {
                ...state,
                onhold: action.onhold
            };
        case STORE_DASHBOARD_RETURNED:
            return {
                ...state,
                returned: action.returned
            };
        case STORE_DASHBOARD_DESIGNREADY:
            return {
                ...state,
                designready: action.designready
            };
        case STORE_CHART:
            return {
                ...state,
                items: action.items
            };
        case STORE_LARGEST_NUMBER:
            return {
                ...state,
                greatest: action.greatest
            };
        case STORE_DASHBOARD_COMPLETEDORDERCNT:
            return {
                ...state,
                completedcnt: action.completedcnt
            };
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/dashboard.tsx